import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

function ScenarioTable({ scenarios = [] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card variant="outlined">
      {!scenarios || !scenarios.length ? (
        <Box sx={{ px: 2, py: 1 }}>
          <Typography>{t('components.scenarioTable.empty')}</Typography>
        </Box>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('components.scenarioTable.name')}</TableCell>
                <TableCell align="right">
                  {t('components.scenarioTable.created')}
                </TableCell>
                <TableCell align="right">
                  {t('components.scenarioTable.updated')}
                </TableCell>
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {scenarios.map((i) => (
                <TableRow
                  key={i.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {i.name}
                  </TableCell>
                  <TableCell align="right">
                    {dayjs(i.created_timestamp).format('LL')}
                  </TableCell>
                  <TableCell align="right">
                    {dayjs(i.updated_timestamp).format('LL')}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => navigate(`../scenarios/${i.id}`)}
                    >
                      <FontAwesomeIcon icon="folder" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}

export default ScenarioTable;
